<template>
  <div class="announcement-page">
    <div class="content-wrapper">
      <!-- Header -->
      <header class="page-header">
        <div class="header-content">
          <div class="header-icon-wrap">
            <v-icon size="28" color="white">mdi-bullhorn</v-icon>
          </div>
          <div class="header-text">
            <h1 class="page-title">Alliance News</h1>
            <p class="page-subtitle">Share important updates with your team</p>
          </div>
        </div>
      </header>

      <!-- Loading -->
      <div v-if="overlay" class="loading-container">
        <v-progress-circular indeterminate color="#8B0000" size="56" width="4" />
        <p class="loading-text">Loading announcement…</p>
      </div>

      <!-- Announcement Card -->
      <v-card v-if="!overlay" class="announcement-card" elevation="0">
        <v-card-text class="card-content">
          <v-form class="announcement-form">
          <v-text-field
            v-model="title"
            class="modern-input"
            outlined
            dense
            label="Announcement Title"
            placeholder="Keep your title short and clear"
            prepend-inner-icon="mdi-format-title"
            color="#8B0000"
          ></v-text-field>

          <v-textarea 
            v-model="description" 
            label="Message Content" 
            class="modern-input mt-4" 
            outlined
            dense
            placeholder="Write your announcement message here..."
            prepend-inner-icon="mdi-message-text"
            color="#8B0000"
            rows="5"
          ></v-textarea>

          <v-btn 
            width="100%" 
            class="submit-btn mt-6" 
            color="#8B0000"
            dark
            large
            elevation="0"
            @click="announcement()"
          >
            <v-icon left small>mdi-send</v-icon>
            {{ getAnnouncement && (getAnnouncement.title || getAnnouncement.description) ? 'Update Announcement' : 'Create Announcement' }}
          </v-btn>
        </v-form>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AllianceNews',

    data: () => ({
      overlay: false,

      description:"",
      title:""
    }),

  async created() {
    this.overlay = true;

    await this.$store.dispatch('dataModules/getAnnouncement')
    .then(() => {
        this.overlay = false;
      })
      .catch(error => {
        console.error('Error fetching feedback:', error);
        this.overlay = false;
      });
    
    if(this.getAnnouncement != "" || this.getAnnouncement !=""){
          this.description = this.getAnnouncement.description;
          this.title = this.getAnnouncement.title;
        }
    },

    computed: {
      getAnnouncement(){
        return this.$store.getters['dataModules/getAnnouncement']
      },
    },

    methods: {
         // announcement
        announcement(){
        if(this.getAnnouncement != "" || this.getAnnouncement !=""){
           this.updateAnnouncement();
        }else{
          this.createAnnouncement();
        }
      },
        
      // createAnnouncement
      async createAnnouncement(){
        console.log('createAnnouncement');

          const data = {
            description: this.description,
            title: this.title,
          }
          const response = this.$store.dispatch('dataModules/createAnnouncement',data)

          if(response.status == 200){
            this.$swal({
                  toast: true,
                  position: "top-end",
                  icon: "success",
                  title: "Successfully Created Announcements!",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
              });
          }
        },

        // updateAnnouncement
        async updateAnnouncement() {
      try {
        console.log('updateAnnouncement');
        
        // Show overlay before making the API request
        this.overlay = true;

        const data = {
          description: this.description,
          id: 1,
          title: this.title,
        };

        if(this.description != "" && this.title !=""){

        // Await the API request completion
       const response = await this.$store.dispatch('dataModules/updateAnnouncement', data);

       if(response.status == 200){
              this.$swal({
                  toast: true,
                  position: "top-end",
                  icon: "success",
                  title: "Successfully Updated Announcements!",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
              });
            }
          }else{
                this.$swal({
                toast: true,
                position: "top-end",
                icon: "error",
                title: "empty fields not allowed!",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                  });
            }
        // Hide overlay after the request is complete (success)
        this.overlay = false;
      } catch (error) {
        console.error('Error updating announcement:', error);

        // Hide overlay after the request is complete (error)
        this.overlay = false;
      }
    },
    },
  }
</script>

<style lang="scss" scoped>
$red-primary: #8B0000;
$red-dark: #5a0000;

.announcement-page {
  min-height: 100vh;
  padding: 12px 0 40px;
}

.content-wrapper {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  
  @media (max-width: 960px) {
    padding: 0 12px;
  }
}

/* ---------- Header ---------- */
.page-header {
  margin-bottom: 16px;
  padding-top: 12px;

  .header-content {
    display: flex;
    align-items: center;
    gap: 16px;

    @media (max-width: 600px) {
      flex-direction: column;
      text-align: center;
    }
  }

  .header-icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: linear-gradient(135deg, $red-primary, $red-dark);
    box-shadow: 0 10px 24px rgba(139, 0, 0, 0.28);
    flex-shrink: 0;
  }

  .header-text {
    flex: 1;
    min-width: 0;
  }

  .page-title {
    font-size: 1.4rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
    letter-spacing: -0.02em;
  }

  .page-subtitle {
    font-size: 0.85rem;
    color: #64748b;
    margin: 2px 0 0;
  }
}

/* Loading */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  gap: 20px;

  .loading-text {
    font-size: 1rem;
    color: #7f8c8d;
  }
}

.announcement-card {
  border-radius: 20px !important;
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(14px);
  border: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.06) !important;
  overflow: hidden;

  .card-content {
    padding: 24px;

    @media (max-width: 960px) {
      padding: 16px;
    }
  }
}

.announcement-form {
  display: flex;
  flex-direction: column;
  gap: 0;
  
  .modern-input {
    ::v-deep .v-input__slot {
      border-radius: 12px !important;
      background: #fbfcfe !important;
    }
  }
}

.submit-btn {
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, $red-primary, $red-dark) !important;
  box-shadow: 0 10px 24px rgba(139, 0, 0, 0.28) !important;
  transition: all 0.25s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(139, 0, 0, 0.35) !important;
  }
}

// Responsive design
@media (max-width: 600px) {
  .page-title {
    font-size: 1.2rem !important;
  }
}
</style>